
import { useEffect } from 'react'
import Select from 'react-select'
import { WaterSupplyWorkPeriodDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WaterSupplyWorkPeriodDataDDL = (props) => {
    const { WaterSupplyWorkPeriod, setWaterSupplyWorkPeriod, CropNameDashboardData, PopUpField, IsPost, WardName, DashProjectTypeId,Flag,rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            // M_WardID: '1',
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,

        }
        dispatch(WaterSupplyWorkPeriodDDLAPI({ data }))
    }, [IsPost])

    const { WaterSupplyWorkPeriodData } = useSelector(state => state.WaterSupplyWorkPeriodDDLData)

    useEffect(() => {
        handleWorkPeriodNameDDL()
    }, [WaterSupplyWorkPeriodData])


    const handleWorkPeriodNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (WaterSupplyWorkPeriodData && WaterSupplyWorkPeriodData.table && WaterSupplyWorkPeriodData.table.length > 0) {
            if (DashProjectTypeId == 6) {
                let list = WaterSupplyWorkPeriodData.table.map((item, index) => ({
                    value: item.m_Distri_WorkPeriodID,
                    label: item.parameterDescription,
                }))
                setWaterSupplyWorkPeriod({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_Distri_WorkPeriodID : 0,
                    Label: Flag === 'Update' ? rowData.parameterDescription : "Select...",
                   
                })
            } else {
                let list = WaterSupplyWorkPeriodData.table.map((item, index) => ({
                    value: item.m_wS_WorkPeriodID,
                    label: item.parameterDescription,
                }))
                setWaterSupplyWorkPeriod({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_wS_WorkPeriodID : 0,
                    Label: Flag === 'Update' ? rowData.parameterDescription : "Select...",
                })
            }
        }
        else {
            setWaterSupplyWorkPeriod({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Work Period </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: WaterSupplyWorkPeriod.ID, label: WaterSupplyWorkPeriod.Label }}
                onChange={(e) => {
                    e ?
                        setWaterSupplyWorkPeriod({ ...WaterSupplyWorkPeriod, ID: e.value, Label: e.label })
                        :
                        setWaterSupplyWorkPeriod({ ...WaterSupplyWorkPeriod, ID: 0, Label: "Select..." })

                }}
                options={WaterSupplyWorkPeriod.DDL}
            />

        </div>
    )
}